import { api } from '../../lib/apiClient';
import type {
  Dashboard,
  LowStockRow,
  ProductHistory,
  ProjectMovementsReport,
  SearchResult,
} from '../../types/api';

/**
 * Panel, reportes y busqueda global.
 *
 * El panel viaja en una sola peticion. Partirlo en seis dejaria la pantalla
 * pintandose a trozos y al cliente componiendo lo que el servidor ya sabe.
 */
export const reportsApi = {
  dashboard: (): Promise<Dashboard> => api.get<Dashboard>('/reports/dashboard'),

  lowStock: (): Promise<LowStockRow[]> => api.get<LowStockRow[]>('/reports/low-stock'),

  projectMovements: (params: {
    project_id: string;
    from?: string;
    to?: string;
  }): Promise<ProjectMovementsReport> =>
    api.get<ProjectMovementsReport>('/reports/project-movements', {
      query: { project_id: params.project_id, from: params.from, to: params.to },
    }),

  productHistory: (productId: string): Promise<ProductHistory> =>
    api.get<ProductHistory>(`/products/${productId}/history`),
};

export const searchApi = {
  search: (term: string): Promise<SearchResult> =>
    api.get<SearchResult>('/search', { query: { q: term } }),
};

export const reportKeys = {
  dashboard: ['reports', 'dashboard'] as const,
  lowStock: ['reports', 'low-stock'] as const,
  projectMovements: (projectId: string, from?: string, to?: string) =>
    ['reports', 'project-movements', projectId, from ?? '', to ?? ''] as const,
  productHistory: (productId: string) => ['reports', 'product-history', productId] as const,
  search: (term: string) => ['search', term] as const,
};
